// 文件错误码
export const fileErrorCodeMap = {
  'file.not.exist': '文件不存在',
  'space.file.not.found': '文件不存在',
  'space.file.revision.not.found': '文件不存在',
  'unsupported.translate.formats': '文件格式不支持转换',
}

// 文件修订版本错误码
const fileRevisionErrorCodeMap = {
  'file.revision.not.exist': '文件修订版本不存在'
}

// 文件列表
export const listErrorCodeMap = {
  'parent.not.found': '父级不存在'
}

// 新建接口错误码
export const newErrorCodeMap = {
  'duplicate.name.error': '存在重名，请修改',
  'name.length.exceed': '名称长度超出限制',
  'name.contain.special.characters': '名称包含特殊字符',
  'unsupported.file.type': '不支持的文件格式',
  'parent.not.found': '父级不存在'
}

// 移动接口错误码
export const moveErrorCodeMap = {
  ...fileErrorCodeMap,
  'batch.move.failed': '目标文件夹不能是当前勾选文件夹及子文件夹',
  'duplicate.name.error': '目标文件夹下存在重名项'
}

// 重命名接口错误码
export const renameErrorCodeMap = {
  ...fileErrorCodeMap,
  'name.length.exceed': '名称长度超出限制',
  'name.contain.special.characters': '名称包含特殊字符'
}

// 删除接口错误码
export const deleteErrorCodeMap = { ...fileErrorCodeMap }

// 批量删除接口错误码
export const batchDeleteErrorCodeMap = { ...fileErrorCodeMap }

// 获取文件版本记录错误码
export const versionRecordsErrorCodeMap = { ...fileErrorCodeMap }

// 下载接口错误码
export const downloadErrorCodeMap = {
  ...fileErrorCodeMap,
  ...fileRevisionErrorCodeMap
}

// 版本记录启用错误码
export const startNewVersionErrorCodeMap = { ...fileRevisionErrorCodeMap }

// 版本记录删除错误码
export const deleteVersionRecordErrorCodeMap = { ...fileRevisionErrorCodeMap }

// 批量下载接口错误码
export const batchDownloadErrorCodeMap = {
  ...fileErrorCodeMap,
  'folder.download.not.supported': '文件夹不支持批量下载'
}

// 合模方案
export const federationErrorCodeMap = {
  'federation.plan.not.exist': '合模方案不存在',
}
export const createdFederationErrorCodeMap = {
  ...fileErrorCodeMap,
  'duplicate.name.error': '存在重名，请修改',
  'name.length.exceed': '名称长度超出限制',
  'name.contain.special.characters': '名称包含特殊字符',
}
export const updateFederationErrorCodeMap = {
  ...fileErrorCodeMap,
  'bimface.file.id.duplicate': '方案中不可存在相同文件',
}
// 整合模型
export const integratedErrorCodeMap = {
  'integrated.model.not.exist': '交付模型不存在',
}

// 分享报错
export const shareModelErrorCodeMap = {
  'federation.plan.not.exist': '合模方案不存在',
  'integrated.model.not.exist': '交付模型不存在',
  'integrated.model.invalid.status': '交付模型状态无效'
}
